<ion-row class="item-row pointer small-screen" aria-setsize="12">
	<ion-col class="ion-no-padding ion-justify-content-center img-block" size="5" [class.add-opacity]="!article.isActive">
		<div *ngIf="checkQuantityIfHasInBasket" class="amount-in-basket">
			<ion-icon alt="selected" src="../../../assets/dean_and_david/selected_item.svg"></ion-icon>
			<p>
				{{ checkQuantityIfHasInBasket }}
			</p>
		</div>
		<ion-img class="item-image cover-image" alt="cover image" *ngIf="article.assets.medium" [src]="article.assets.medium"></ion-img>
		<ion-img
			class="item-image default-image"
			alt="default image"
			*ngIf="!article.assets.medium"
			src="../../../assets/dean_and_david/logo.png"
		></ion-img>

		<div class="tags_article" *ngIf="findFeatureArray.length > 0">
			<ion-icon alt="new icon" src="../../../assets/dean_and_david/article_tags/new.svg"></ion-icon>
		</div>
		<div class="section_favourite" *ngIf="showMostWanted">
			<ion-icon alt="favourite" src="../../../assets/dean_and_david/like.svg"></ion-icon>
		</div>
	</ion-col>
	<ion-col class="item-text ion-no-padding" size="7" [class.add-opacity]="!article.isActive">
		<div class="block_type">
			<ng-container *ngIf="checkVeganFeatureValue">
				<div class="vegan-block">
					<ion-img
						alt="veggie box"
						[src]="'../../../assets/dean_and_david/slider-veggie/' + checkVeganFeatureValue + '.png'"
					></ion-img>
				</div>
			</ng-container>

			<ion-icon
				alt="nutrition"
				(click)="showNutrition(article); $event.stopPropagation()"
				src="../../../assets/dean_and_david/info.svg"
			></ion-icon>
		</div>
		<ion-row class="name-section">
			<h3 class="item-name">
				{{ article.name | langObservable | async }}
			</h3>
			<p class="item-info">
				{{ article.description | langObservable | async }}
				@if (basePrice) {
					<br />
					{{ basePrice }}
				}
			</p>
		</ion-row>
		<!-- <ion-row class="ion-align-items-center">

			<p></p>
		</ion-row> -->
		<ion-row>
			<div class="price-wrapper">
				<p class="price font-16">
					{{ article && article.isFromPrice ? ('item_view.price_from' | translate) : '' }}
					{{ priceText }}
					<ng-container *ngIf="!hasOrder">*</ng-container>
					@if (measurmentText) {
						<br />
						<span class="item-info" [innerHTML]="measurmentText"></span>
					}
					<!-- <span class="info vat"><br />{{ 'item_view.VAT' | translate }}</span> -->
				</p>
				<div class="not-order-item" *ngIf="!article.isActive">
					<p class="text-not-visible">
						{{ 'not_visible' | translate }}
					</p>
				</div>
			</div>
		</ion-row>
	</ion-col>
</ion-row>
